import { CircularProgress } from "drift-ui";
import * as React from "react";

interface Props {
  size?: string;
  useWait?: boolean;
}

const SpinnerWithWait: React.FunctionComponent<Props> = ({
  size,
  useWait = true,
}) => {
  const [showSpinner, setShowSpinner] = React.useState(false);

  React.useEffect(() => {
    if (useWait) {
      const timeout = setTimeout(() => {
        setShowSpinner(true);
      }, 500);

      return () => {
        clearTimeout(timeout);
      };
    }
    setShowSpinner(true);
  }, [setShowSpinner, useWait]);

  return showSpinner ? (
    <div>
      <CircularProgress size={size}></CircularProgress>
    </div>
  ) : null;
};

export default SpinnerWithWait;
